import type { PaletteColor } from "../types/PaletteColor.ts";

/**
 * Chatis 本体の URL。
 * chat_react/src/Common/Common.js の MAIN_URL と対応させること。
 * ローカル開発で Chatis 本体を立てる場合は開発用の行に差し替える。
 */
export const CHATIS_URL = "https://chatis-sub.info";
// export const CHATIS_URL = "https://localhost:7107"; // 開発環境

/** /goto に渡すアプリ種別（Chatis 側の kbn と一致させること） */
export type GotoApp = "todo" | "note" | "calendar" | "files";

export type GotoParams = {
  app: GotoApp;
  roomId: number | string;
  color?: PaletteColor | string;
  /** true = ダークモード。未指定なら Chatis 側の既定に従う */
  isDarkMode?: boolean;
  /** ショートカット起動として遷移先を開かせる場合に true */
  shortcut?: boolean;
  /** 遷移先へそのまま引き継ぐ追加クエリ（ファイルアプリの hpcode など） */
  extra?: Record<string, string>;
};

/**
 * Chatis 本体の着地ルート `/goto` の URL を組み立てる。
 *
 * TODO の API は Chatis で発行された temp token を消費してはじめてアクセストークンを得るため、
 * ショートカット起動・セッション切れからの復帰は必ずこの URL を経由して Chatis に
 * ログイン確認とトークン発行をしてもらう。
 * honbuid は Chatis 側が自身のログイン情報から補うため、ここでは渡さない。
 */
export function buildGotoUrl(params: GotoParams): string {
  const query = new URLSearchParams({
    app: params.app,
    roomid: String(params.roomId),
  });
  if (params.color) query.set("color", String(params.color));
  if (params.isDarkMode !== undefined) {
    query.set("mode", params.isDarkMode ? "dark" : "light");
  }
  if (params.shortcut) query.set("shortcut", "1");
  Object.entries(params.extra ?? {}).forEach(([key, value]) => {
    query.set(key, value);
  });
  return `${CHATIS_URL}/goto?${query.toString()}`;
}
